module.exports = __webpack_public_path__ + "img/logo-chu-grenoble.91029b3.png";